<h1 mat-dialog-title>Schlachthof auswählen</h1>
<div mat-dialog-content>
    <mat-form-field>
        <mat-label>Schlachthof</mat-label>
        <mat-select [formControl]="schlachthofCtrl">
            <mat-option *ngFor="let s of schlachthoefe" [value]="s">{{ s.bezeichnung }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="cancel()" mat-button>Abbrechen</button>
    <button (click)="select()" [disabled]="!schlachthofCtrl.value" color="accent" mat-flat-button>Senden</button>
</div>
